__turbopack_context__.v({
  "Buttons": "OfficeInfo-module-scss-module__StN-Wq__Buttons",
  "Inner": "OfficeInfo-module-scss-module__StN-Wq__Inner",
  "IsSubpage": "OfficeInfo-module-scss-module__StN-Wq__IsSubpage",
  "OfficeInfo": "OfficeInfo-module-scss-module__StN-Wq__OfficeInfo",
  "OfficeLocations": "OfficeInfo-module-scss-module__StN-Wq__OfficeLocations",
  "OfficeTitle": "OfficeInfo-module-scss-module__StN-Wq__OfficeTitle",
  "Text": "OfficeInfo-module-scss-module__StN-Wq__Text",
});
